import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Comprime = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75.99 75.97">
  <G fill={color}>
    <Path d="M69.01,16.06C63.15,7.78,54.42,2.27,44.41.56c-10-1.72-20.07.57-28.35,6.43C7.78,12.84,2.27,21.57.56,31.58c-1.72,10,.57,20.07,6.43,28.35,7.39,10.45,19.14,16.04,31.07,16.04,7.58,0,15.23-2.26,21.88-6.96,8.28-5.86,13.79-14.59,15.5-24.59,1.71-10-.57-20.07-6.43-28.35ZM26.64,21.94c2.49-1.76,5.94-1.17,7.7,1.32l16.33,23.09c1.76,2.49,1.17,5.94-1.32,7.7-.97.69-2.08,1.01-3.19,1.01-1.73,0-3.44-.81-4.52-2.33l-16.33-23.09c-1.76-2.49-1.17-5.94,1.32-7.7Z"/>
  </G>
</Svg>
);
};

export default Comprime;
